import { render, staticRenderFns } from "./RecommendersManage.vue?vue&type=template&id=005ff026&scoped=true"
import script from "./RecommendersManage.vue?vue&type=script&lang=js"
export * from "./RecommendersManage.vue?vue&type=script&lang=js"
import style0 from "./RecommendersManage.vue?vue&type=style&index=0&id=005ff026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ff026",
  null
  
)

export default component.exports